import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

export interface UnsavedChangesDialogProps {
  open: boolean
  onConfirm: () => void
  onDismiss: () => void
  title?: string
  message?: string
  confirmButtonText?: string
  dismissButtonText?: string
}

/**
 * Reusable dialog component to warn users about unsaved changes
 */
const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onConfirm,
  onDismiss,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes. Are you sure you want to leave?',
  confirmButtonText = 'Yes, Leave Page',
  dismissButtonText = 'No, Stay Here',
}) => {
  return (
    <Dialog open={open} onClose={onDismiss}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="primary">
          {dismissButtonText}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnsavedChangesDialog
